export const SET_ACTUAL_PAGE = 'transaction//SET_ACTUAL_PAGE'
export const SET_SESSION_EXPIRED = 'transaction//SET_SESSION_EXPIRED'
export const SET_PAGE_VISITED = 'transaction//SET_PAGE_VISITED'

interface SetActualPageAction {
  type: typeof SET_ACTUAL_PAGE
  payload: { data: string }
}

interface SetSessionExpired {
  type: typeof SET_SESSION_EXPIRED
  payload: { data: boolean }
}

interface SetLastPageVisited {
  type: typeof SET_PAGE_VISITED
  payload: { data: string }
}

export type TransactionActions = SetActualPageAction | SetSessionExpired | SetLastPageVisited
